var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { providers, provider } from 'helpers/Providers';
import { Icon } from 'elements';
import Icomoon from '../elements/Icomoon';
var logo = {
    width: 88.5,
    height: 20
};
var powered = {
    width: 45,
    height: 5
};
var Logo = /** @class */ (function (_super) {
    __extends(Logo, _super);
    function Logo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Logo.prototype.render = function () {
        var _a = this.props, _width = _a.width, props = __rest(_a, ["width"]);
        var width = _width || 200;
        if (provider === providers.redsys)
            return React.createElement("img", __assign({}, props, { width: width, src: "/assets/images/redsys.png" }));
        var logoHeight = logo.height * width / logo.width;
        var poweredHeight = powered.height * width / logo.width;
        return (React.createElement(Wrapper, __assign({}, props),
            React.createElement(StyledLogo, { name: "logo", size: logoHeight - 15 })));
    };
    return Logo;
}(Component));
export default Logo;
var Wrapper = cxs('div')({
    textAlign: 'right'
});
var icon = {
    display: 'block !important',
    padding: 0
};
var StyledLogo = cxs(Icomoon)(__assign(__assign({}, icon), { color: Theme.color.primary }));
var StyledPowered = cxs(Icon)(function (_a) {
    var size = _a.size;
    return (__assign(__assign({}, icon), { color: Theme.color.primary, marginTop: Theme.common.size.space * size / 20 + 'px' }));
});
var StyledCreanimund = cxs('label')(function (_a) {
    var size = _a.size;
    return (__assign(__assign({}, icon), { marginTop: Theme.common.size.space * size / 20 + 'px' }));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/Logo.tsx
// module id = 1039
// module chunks = 0